import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { commercialConstants } from '../../../../common/commercial-constants';
import { LoggerService } from '../../../../shared/services/logger.service';
import { ClaimsDataService } from '../../services/claims-data.service';
import { CommercialLoggingService } from '../../services/commercial-logging.service';
import { GetClaimsService } from '../../services/get-claims.service';
@Component({
    selector: 'is-search-claim',
    templateUrl: './search-claim.component.html',
    styleUrls: ['./search-claim.component.scss'],
    standalone: false
})
export class SearchClaimComponent implements OnInit {
    claimInfo;
    isError = false;
    subscription = new Subscription();

    constructor(private getClaimsService: GetClaimsService,
        public claimsDataService: ClaimsDataService,
        private LOGGER: LoggerService,
        private router: Router,
        private commercialLoggingService: CommercialLoggingService
    ) { }
    getClaimInformation(searchInput: string): void {
        const reg = searchInput.match(/^(\d{6})-[A-Z]{2}$/);
        if (reg == null) {
            this.isError = true;
        } else {
            this.getClaimsService.getClaims(searchInput).pipe(take(1)).subscribe((response) => {
                this.isError = false;
                this.claimsDataService.setClaimNumber(searchInput);
                this.commercialLoggingService.logServiceSuccess(
                    this.LOGGER,
                    'Search Claim',
                    'GetClaimsService',
                    'getClaims',
                    this.getLogMetadata({ claimNumber: searchInput, claimsDisplayCount: '1' })
                );
                this.commercialLoggingService.logButtonAction(
                    this.LOGGER,
                    'Search Claim',
                    'search-claim',
                    'success',
                    this.getLogMetadata({ claimNumber: searchInput, claimsDisplayCount: '1' })
                );
                this.commercialLoggingService.updatePreviousUrlContext();
                this.router.navigate([commercialConstants.URLS.claimOverview]);
            }, (error) => {
                this.commercialLoggingService.logServiceFailure(
                    this.LOGGER,
                    'Search Claim',
                    'GetClaimsService',
                    'getClaims',
                    this.getLogMetadata({ claimNumber: searchInput }),
                    error
                );
                this.commercialLoggingService.logButtonAction(
                    this.LOGGER,
                    'Search Claim',
                    'search-claim',
                    'failure',
                    this.getLogMetadata({ claimNumber: searchInput })
                );
                this.isError = true;
            });
        }
    }
    navigateToClaimOverview(searchInput: string): void {
        const unformatted = 8;
        const formatted = 9;
        const splitIndex = 6;
        this.claimsDataService.setPremisisID(null);
        this.claimsDataService.setFromSearch(true);
        if (searchInput.length === unformatted) {
            searchInput = `${searchInput.slice(0, splitIndex)}-${searchInput.slice(0, splitIndex)}`;
            this.getClaimInformation(searchInput.toUpperCase());
        } else if (searchInput.length === formatted) {
            this.getClaimInformation(searchInput.toUpperCase());
        } else {
            this.commercialLoggingService.logButtonAction(
                this.LOGGER,
                'Search Claim',
                'search-claim',
                'invalid',
                this.getLogMetadata({ claimNumber: searchInput })
            );
            this.isError = true;
        }
    }

    ngOnInit(): void {
        this.claimInfo = this.claimsDataService.getClaimInformation();
        this.commercialLoggingService.logPageLoad(this.LOGGER, 'Search Claim', this.getLogMetadata());
    }

    private getLogMetadata(additionalFields: any = {}): any {
        return {
            policyNumber: this.claimsDataService.getClaimsPolicyNumber(),
            policyType: this.claimsDataService.getClaimsPolicyType(),
            lineOfBusiness: this.claimsDataService.getFnolFlow(),
            claimsDisplayCount: this.claimsDataService.getClaimsDisplayCount() || 'UNKNOWN',
            alphaState: this.claimsDataService.getPrimary(this.claimsDataService.getClaimsPackage()?.address)?.state || 'UNKNOWN',
            previousUrl: window.sessionStorage.getItem('previousUrl') || '',
            ...additionalFields
        };
    }
}
